import Icon from './Icon';

const UtsavReferIcon = (props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2614_35435)">
        <rect
          opacity="0.3"
          width="8.4"
          height="21.2"
          transform="matrix(-1 0 0 1 12 14)"
          fill="url(#paint0_linear_2614_35435)"
          fillOpacity="0.48"
        />
        <path
          d="M4.24151 17.1641C4.36485 17.4531 4.69913 17.5874 4.98814 17.464L11.791 14.5607C12.08 14.4373 12.2143 14.103 12.0909 13.814L9.85757 8.58106L2.00813 11.9311L4.24151 17.1641Z"
          fill="#FFC670"
        />
        <path
          d="M1.07588 10.4718C0.952531 10.1828 1.08683 9.84849 1.37584 9.72515L8.70198 6.59842C8.99099 6.47508 9.32527 6.60937 9.44862 6.89838L10.1745 8.59909C10.2053 8.67135 10.1717 8.75492 10.0995 8.78575L1.98838 12.2475C1.91613 12.2783 1.83256 12.2447 1.80172 12.1725L1.07588 10.4718Z"
          fill="#FFDB93"
        />
        <path
          d="M3.99219 8.60846L6.08537 7.71511L9.43543 15.5646C9.49711 15.7091 9.42996 15.8762 9.28546 15.9379L7.71557 16.6079C7.57106 16.6696 7.40392 16.6024 7.34225 16.4579L3.99219 8.60846Z"
          fill="#FF9706"
        />
        <path
          d="M5.43115 7.99428L2.55302 9.22265C2.40851 9.28433 2.24137 9.21718 2.1797 9.07267L1.70411 7.95831C1.61792 7.75637 1.78328 7.53706 2.00114 7.56437L5.43115 7.99428Z"
          fill="#FF9706"
        />
        <path
          d="M4.27644 8.48711L7.15458 7.25877C7.29909 7.19709 7.36624 7.02995 7.30456 6.88545L6.82896 5.77109C6.74277 5.56915 6.47002 5.53683 6.33901 5.71302L4.27644 8.48711Z"
          fill="#FF9706"
        />
        <circle
          cx="4.6286"
          cy="7.56349"
          r="0.711203"
          transform="rotate(-23.1123 4.6286 7.56349)"
          fill="#FF9706"
        />
        <path
          d="M12.7886 14.8333C12.7923 14.8224 12.8077 14.8224 12.8114 14.8333L12.8679 14.9983C13.0207 15.4443 13.2683 15.852 13.5936 16.1933C13.5972 16.197 13.5972 16.2029 13.5936 16.2067C13.2683 16.5479 13.0207 16.9556 12.8679 17.4017L12.8114 17.5667C12.8077 17.5776 12.7923 17.5776 12.7886 17.5667L12.7321 17.4017C12.5793 16.9556 12.3317 16.5479 12.0064 16.2067C12.0028 16.2029 12.0028 16.197 12.0064 16.1933C12.3317 15.852 12.5793 15.4443 12.7321 14.9983L12.7886 14.8333Z"
          fill="#FFD670"
        />
        <path
          d="M7.57719 24.0666C7.58463 24.0449 7.61537 24.0449 7.62281 24.0666L7.73583 24.3966C8.0414 25.2887 8.53656 26.1041 9.18725 26.7866C9.19439 26.7941 9.19439 26.8059 9.18725 26.8134C8.53656 27.4959 8.0414 28.3113 7.73583 29.2034L7.62281 29.5334C7.61537 29.5551 7.58463 29.5551 7.57719 29.5334L7.46417 29.2034C7.1586 28.3113 6.66344 27.4959 6.01275 26.8134C6.00561 26.8059 6.00561 26.7941 6.01275 26.7866C6.66344 26.1041 7.1586 25.2887 7.46417 24.3966L7.57719 24.0666Z"
          fill="#FFD670"
        />
        <path
          d="M10.7774 1.66658C10.7848 1.64484 10.8156 1.64484 10.823 1.66658L10.936 1.99655C11.2416 2.88868 11.7368 3.70405 12.3874 4.3866C12.3946 4.39409 12.3946 4.40586 12.3874 4.41335C11.7368 5.0959 11.2416 5.91127 10.936 6.8034L10.823 7.13338C10.8156 7.15511 10.7848 7.15511 10.7774 7.13338L10.6644 6.8034C10.3588 5.91127 9.86364 5.0959 9.21295 4.41335C9.20581 4.40586 9.20581 4.39409 9.21295 4.3866C9.86364 3.70405 10.3588 2.88868 10.6644 1.99655L10.7774 1.66658Z"
          fill="#FFD670"
        />
        <path
          d="M2.78617 18.8461C2.79028 18.8324 2.80972 18.8324 2.81383 18.8461L2.87832 19.0613C3.02446 19.5489 3.26794 20.0019 3.59402 20.3928C3.59749 20.397 3.59749 20.403 3.59402 20.4072C3.26794 20.7981 3.02446 21.251 2.87832 21.7387L2.81383 21.9538C2.80972 21.9676 2.79028 21.9676 2.78617 21.9538L2.72168 21.7387C2.57554 21.251 2.33206 20.7981 2.00598 20.4072C2.00251 20.403 2.00251 20.397 2.00598 20.3928C2.33206 20.0019 2.57554 19.5489 2.72168 19.0613L2.78617 18.8461Z"
          fill="#FFD670"
        />
        <path
          d="M21.3975 22.6279L29.1011 31.9465L25.9981 35.2447L18.8415 24.0955L18.3087 23.9803C18.0544 23.9253 17.8258 23.787 17.6591 23.5873L15.5354 21.043L13.3826 19.64C13.2585 19.5592 13.1871 19.4182 13.1953 19.2703C13.2111 18.9855 13.5035 18.8016 13.7671 18.9108L16.2731 19.9491L14.0432 16.8781C13.9727 16.781 13.9469 16.6585 13.9723 16.5412C14.0448 16.2062 14.4654 16.0929 14.6962 16.3463L17.2666 19.1679L15.8269 14.8697C15.7683 14.6947 15.8376 14.5023 15.9944 14.4048C16.1961 14.2795 16.462 14.3573 16.5642 14.5717L18.4348 18.4942L18.1511 15.2166C18.1342 15.0225 18.2676 14.8473 18.4593 14.8119C18.6617 14.7745 18.8569 14.9058 18.8986 15.1074L19.5425 18.2221L20.7816 20.5466L21.7676 18.5538C21.7884 18.5117 21.8187 18.475 21.8561 18.4466C22.0842 18.273 22.4039 18.4821 22.3363 18.7606L21.3975 22.6279Z"
          fill="#F9B8A4"
        />
        <mask
          id="mask0_2614_35435"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="13"
          y="14"
          width="17"
          height="22"
        >
          <path
            d="M21.3975 22.6279L29.1011 31.9465L25.9981 35.2447L18.8415 24.0955L18.3087 23.9803C18.0544 23.9253 17.8258 23.787 17.6591 23.5873L15.5354 21.043L13.3826 19.64C13.2585 19.5592 13.1871 19.4182 13.1953 19.2703C13.2111 18.9855 13.5035 18.8016 13.7671 18.9108L16.2731 19.9491L14.0432 16.8781C13.9727 16.781 13.9469 16.6585 13.9723 16.5412C14.0448 16.2062 14.4654 16.0929 14.6962 16.3463L17.2666 19.1679L15.8269 14.8697C15.7683 14.6947 15.8376 14.5023 15.9944 14.4048C16.1961 14.2795 16.462 14.3573 16.5642 14.5717L18.4348 18.4942L18.1511 15.2166C18.1342 15.0225 18.2676 14.8473 18.4593 14.8119C18.6617 14.7745 18.8569 14.9058 18.8986 15.1074L19.5425 18.2221L20.7816 20.5466L21.7676 18.5538C21.7884 18.5117 21.8187 18.475 21.8561 18.4466C22.0842 18.273 22.4039 18.4821 22.3363 18.7606L21.3975 22.6279Z"
            fill="#F9B8A4"
          />
        </mask>
        <g mask="url(#mask0_2614_35435)">
          <path
            d="M18.9108 24.9549L18.4379 24.2225L18.9862 23.9315L19.8328 23.5137C19.8632 23.4987 19.894 23.5334 19.8755 23.5618L19.3987 24.2948L18.9108 24.9549Z"
            fill="#F49D82"
          />
        </g>
        <path
          d="M25.5129 11.4748C26.5388 9.01971 24.9532 6.26039 22.3155 5.91038L21.6795 5.82599C20.0251 5.60646 18.4059 6.42644 17.6038 7.88996L17.5433 8.00039C16.3896 10.1055 17.3143 12.7463 19.5293 13.6718L20.113 13.9157C22.1725 14.7762 24.5396 13.8043 25.4002 11.7448L25.5129 11.4748Z"
          fill="#3F2121"
        />
        <circle
          cx="6.41475"
          cy="6.41475"
          r="6.41475"
          transform="matrix(0.997404 0.0720115 0.0720115 -0.997404 16.5381 17.0731)"
          fill="#3F2121"
        />
        <circle cx="21.0002" cy="14.6" r="5.8" fill="#3F2121" />
        <path
          d="M27.461 17.3825C27.2328 20.543 24.7171 22.9367 21.8419 22.7292C18.9668 22.5216 17.0317 21.2994 17.2599 18.139C17.4881 14.9785 18.1777 10.9599 22.6683 11.2841C25.5434 11.4917 27.6892 14.222 27.461 17.3825Z"
          fill="#3F2121"
        />
        <path
          d="M18.1173 11.0497L15.6956 14.2239C15.5637 14.3967 15.6151 14.6462 15.8045 14.7528L17.7644 15.8561L19.6336 19.31L21.8906 24.4527L26.6737 21.9989L21.7581 12.4168L18.1173 11.0497Z"
          fill="#F9B8A4"
        />
        <mask
          id="mask1_2614_35435"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="19"
          y="17"
          width="8"
          height="9"
        >
          <path
            d="M25.0321 17.2526L19.4741 19.0029L22.3145 25.3174L26.1416 19.4154L25.0321 17.2526Z"
            fill="#F9B8A4"
          />
        </mask>
        <g mask="url(#mask1_2614_35435)">
          <path
            d="M19.1049 20.509C19.0755 20.2726 19.1489 19.336 18.72 19.0678L22.3752 18.6876C22.6203 18.6622 22.7805 18.9004 22.6086 19.077C21.6404 20.0715 19.1334 20.7386 19.1049 20.509Z"
            fill="#F49D82"
          />
        </g>
        <circle
          cx="1.39056"
          cy="1.39056"
          r="1.39056"
          transform="matrix(-0.948476 0.316849 0.316849 0.948476 21.0039 12.5962)"
          fill="#F49D82"
        />
        <path
          d="M17.5211 10.2324C18.7004 6.63846 21.011 6.79014 23.2227 7.51592C25.4342 8.24196 26.9571 11.8117 25.7778 15.4054C25.0297 19.0111 21.6709 19.3365 19.1099 19.0222C17.2651 18.7958 16.1363 17.0478 16.4085 15.2092C16.6312 13.7052 16.9822 11.8745 17.5211 10.2324Z"
          fill="#F9B8A4"
        />
        <path
          d="M30.0427 17.8171L24.8235 19.4789C22.0439 20.5136 20.2003 23.1671 20.2003 26.133L20.2003 41.8L41.4143 36.55L34.3731 19.8143C33.7973 18.4459 32.4278 17.5831 30.9448 17.6546C30.6383 17.6693 30.3351 17.724 30.0427 17.8171Z"
          fill="#E23D5A"
        />
        <path
          d="M23.2823 38.831C26.1133 40.2759 29.8651 38.0442 31.6194 36.4348L28.7712 32.0304C27.9591 32.6174 25.2066 33.3656 24.8033 33.8433C24.4851 34.2202 18.308 29.8777 15.8757 27.8544L14.4304 29.4488C15.8949 31.8062 20.4513 37.3862 23.2823 38.831Z"
          fill="#F9B8A4"
        />
        <path
          d="M14.4813 29.5586L11.8052 26.325C11.1492 25.5323 10.9026 24.478 11.1391 23.4766C11.4016 23.0814 12.0024 23.1541 12.163 23.6006L12.5454 24.6639L14.5041 26.3176L15.8754 27.8547L14.4813 29.5586Z"
          fill="#F9B8A4"
        />
        <path
          d="M10.4734 25.3379L8.75548 22.0903C8.6257 21.845 8.81184 21.5515 9.08909 21.5644C9.15723 21.5676 9.22217 21.5942 9.27285 21.6399L11.7062 23.8317L14.1403 25.8867C13.5055 25.9041 13.1647 26.6404 13.5623 27.1355L15.1115 29.0648L14.6362 29.7136L11.2053 26.3231C10.9126 26.0339 10.6658 25.7017 10.4734 25.3379Z"
          fill="#F9B8A4"
        />
        <rect
          width="3.01745"
          height="1.19446"
          rx="0.35897"
          transform="matrix(-0.751313 0.659946 0.659946 0.751313 16.1924 27.3898)"
          fill="#092D5C"
        />
        <path
          d="M12.4675 26.1506C12.4675 26.835 13.0917 27.3898 13.8616 27.3898C14.6316 27.3898 15.2558 27.4546 15.2558 26.7702C15.4107 25.531 12.9277 23.3624 12.1577 23.3624C11.3878 23.3624 12.4675 25.4662 12.4675 26.1506Z"
          fill="#F9B8A4"
        />
        <path
          d="M10.4917 22.9808C10.4471 22.9325 10.3755 22.9205 10.3176 22.9515C10.2464 22.9897 10.2204 23.079 10.2602 23.1494L11.3932 25.1548C11.5235 25.3854 11.8347 25.4343 12.0295 25.2547C12.1963 25.1009 12.2068 24.841 12.053 24.6741L10.4917 22.9808Z"
          fill="#DB8C74"
        />
        <path
          d="M9.75131 19.52C9.57808 19.3044 9.33486 19.1727 9.0724 19.1522L8.14475 19.0797C7.84227 19.0561 7.658 19.4488 7.85279 19.7019L12.9869 26.373C13.2052 26.6566 13.5391 26.799 13.8776 26.7528L14.7441 26.6345C15.0187 26.597 15.147 26.2341 14.9655 26.0083L9.75131 19.52Z"
          fill="#092D5C"
        />
        <path
          d="M9.93842 19.615C9.81699 19.4601 9.64219 19.3684 9.4551 19.3615L8.50717 19.3266C8.3285 19.3201 8.22481 19.5523 8.34006 19.701L13.1768 25.9396C13.3247 26.1304 13.5512 26.2243 13.7793 26.1893L14.6981 26.0482C14.806 26.0316 14.8561 25.8893 14.7856 25.7994L9.93842 19.615Z"
          fill="white"
        />
        <path
          d="M11.9627 22.4682C11.7963 22.2564 11.5346 22.1679 11.2853 22.2391L10.9317 22.3402C10.7832 22.3826 10.7247 22.5824 10.8238 22.7085L12.04 24.2564C12.2064 24.4682 12.4681 24.5567 12.7174 24.4855L13.1792 24.3535C13.2782 24.3252 13.3172 24.1921 13.2511 24.108L11.9627 22.4682Z"
          fill="#F4EBEB"
        />
        <path
          d="M10.3495 20.3713C10.2231 20.215 10.0419 20.126 9.85036 20.126L9.3401 20.126C9.1654 20.126 9.06727 20.3523 9.17848 20.4987L10.1345 21.7575C10.2794 21.9484 10.5026 22.0448 10.7292 22.0146L11.323 21.9353C11.4332 21.9206 11.4847 21.7748 11.4116 21.6844L10.3495 20.3713Z"
          fill="#F4EBEB"
        />
        <path
          d="M12.6034 23.5005L14.2085 26.4254C14.3412 26.6671 14.376 26.9505 14.306 27.2172L14.0163 28.3196L12.3124 26.6156L11.8477 25.3764L12.0025 25.0666L11.9302 23.6921C11.9101 23.311 12.4198 23.166 12.6034 23.5005Z"
          fill="#F9B8A4"
        />
        <path
          d="M23.42 9.84733C23.1748 8.38445 24.0508 6.96609 25.4687 6.53044C26.9458 6.07658 28.5234 6.8361 29.0898 8.27382L32.8952 17.9327C33.7426 20.0837 32.0899 22.3932 29.7804 22.285L26.3324 22.1236C24.3604 22.0312 22.9458 20.1868 23.3677 18.2583L24.1958 14.4738L23.42 9.84733Z"
          fill="#3F2121"
        />
        <path
          d="M33.7053 18.3458C33.4977 21.2209 30.9987 23.3834 28.1236 23.1758C25.2484 22.9683 23.3063 21.8433 23.5139 18.9682C23.7215 16.093 24.3847 12.4398 28.8753 12.764C31.7504 12.9716 33.9129 15.4707 33.7053 18.3458Z"
          fill="#3F2121"
        />
        <circle cx="25.0002" cy="17.4" r="3.8" fill="#3F2121" />
        <circle cx="27.8" cy="13" r="3.8" fill="#3F2121" />
        <ellipse
          cx="23.246"
          cy="8.90421"
          rx="2.36314"
          ry="4.17298"
          transform="rotate(-44.1598 23.246 8.90421)"
          fill="#3F2121"
        />
        <ellipse
          cx="1.35745"
          cy="2.58058"
          rx="1.35745"
          ry="2.58058"
          transform="matrix(-0.609885 -0.79249 -0.79249 0.609885 22.3213 7.17389)"
          fill="#3F2121"
        />
        <circle
          cx="1.42789"
          cy="1.42789"
          r="1.42789"
          transform="matrix(-0.784417 0.620234 0.620234 0.784417 20.915 12.3942)"
          fill="#F49D82"
        />
        <path
          d="M19.5388 16.9368C18.839 17.1545 17.7842 16.647 17.5063 15.9688C17.4964 15.9446 17.4874 15.9197 17.4795 15.8943C17.3295 15.412 17.6056 14.8974 18.0957 14.7447C18.4957 14.6201 19.0031 14.4819 19.3954 14.3347C19.4149 14.3274 19.4348 14.3206 19.4549 14.3143C20.0123 14.1407 20.6 14.4369 20.7678 14.9757C20.8236 15.1549 20.826 15.3384 20.7837 15.5099C20.6365 16.1075 20.1265 16.7538 19.5388 16.9368Z"
          fill="white"
        />
        <path
          d="M20.1628 12.2426C20.3789 11.9255 19.6082 11.0834 18.8879 10.6596C18.5974 10.4887 18.2617 10.6642 18.1434 10.9798C18.1133 11.0601 18.164 11.149 18.2453 11.176C18.9157 11.3991 20.1018 12.3321 20.1628 12.2426Z"
          fill="#3F2121"
        />
        <path
          d="M23.5242 13.0227C23.6299 13.791 23.6471 14.469 24.1893 14.3944C24.3763 14.3687 25.5931 13.5209 25.4873 12.7526C25.3816 11.9842 24.8564 11.4218 24.3143 11.4964C23.7722 11.571 23.4184 12.2543 23.5242 13.0227Z"
          fill="#F9B8A4"
        />
        <path
          d="M24.5211 12.9643C24.5318 13.0293 24.5931 13.0733 24.6581 13.0626C24.723 13.0519 24.767 12.9906 24.7563 12.9256C24.7407 12.8309 24.6976 12.6906 24.6144 12.5731C24.5297 12.4533 24.3923 12.3442 24.1952 12.3577C24.1296 12.3622 24.08 12.419 24.0845 12.4847C24.089 12.5504 24.1458 12.6 24.2115 12.5955C24.2338 12.5939 24.2548 12.5957 24.2746 12.6004C24.223 12.6151 24.1746 12.6367 24.1336 12.671C24.0578 12.7346 24.028 12.8229 24.0176 12.9199C24.0106 12.9853 24.058 13.044 24.1235 13.051C24.1889 13.058 24.2476 13.0106 24.2546 12.9452C24.2617 12.8793 24.2772 12.8617 24.2867 12.8538C24.3019 12.841 24.3353 12.8258 24.4204 12.8139C24.4381 12.8115 24.4544 12.8052 24.4685 12.7961C24.4962 12.856 24.5134 12.9178 24.5211 12.9643Z"
          fill="#DB8C74"
        />
        <path
          d="M23.197 11.241C23.147 11.9841 23.3 12.9796 23.5701 12.9977C23.8402 13.0159 24.1252 12.0498 24.1751 11.3068C24.2251 10.5637 24.0467 9.94658 23.7765 9.92841C23.5064 9.91025 23.2469 10.4979 23.197 11.241Z"
          fill="#3F2121"
        />
        <path
          d="M17.99 12.5809C18.3014 12.4722 18.9544 12.4189 19.0746 13.075"
          stroke="#3F2121"
          strokeWidth="0.32"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2614_35435"
          x1="4.2"
          y1="0"
          x2="4.2"
          y2="21.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9706" />
          <stop offset="1" stopColor="#FF9706" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2614_35435">
          <rect width="32" height="32" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export default UtsavReferIcon;
